/**
 * The app's name and the one composition rule for browser tab titles (§12.1).
 *
 * Lives in `app/` with the rest of the shell/branding, so `useDocumentTitle` in `lib/hooks.ts`
 * stays a generic DOM utility with no opinion about what a title says.
 *
 * `packages/web/index.html` necessarily repeats the literal — it cannot import TypeScript, and it is
 * the correct pre-hydration value.
 */

export const APP_NAME = 'LinkedIn Watcher';

/**
 * `pageTitle()` → `"LinkedIn Watcher"`; `pageTitle('Profiles')` → `"Profiles · LinkedIn Watcher"`.
 *
 * The page part is whatever names the screen — a static word for the fixed screens, or
 * `"<subject> — <mode>"` for the view.
 */
export function pageTitle(page?: string): string {
  return page === undefined || page.length === 0 ? APP_NAME : `${page} · ${APP_NAME}`;
}
